export default "__VITE_ASSET__vlshPLBD__"